import phoneCodes from 'assets/phoneCodes.json'

/**
 * @param phone - phone number
 * @param countryCode - short country code (US, CA, etc)
 * @returns phone number with country code in the format of +1 (XXX) XXX - XXXX
 */
export const getPhoneWithCountryCode = (phone: string, countryCode?: string) => {
  // return if no phone number provided
  if (!phone) return { phone: '', mask: '' }

  // setting the default mask and the full phone number
  let mask = '(XXX) XXX - XXXX'

  // if there is a country code
  if (countryCode) {
    // Looking for the country with the same code as the default address country
    const country = phoneCodes.find(({ code }) => code === countryCode)

    if (country) {
      // Creating a string of Xs with the length of the country code
      // eslint-disable-next-line unicorn/no-new-array
      const countryMask = new Array(country?.dialCode?.length + 1).join('X')

      // Creating a mask with the country code and the phone number
      mask = `+${countryMask} ${mask}`
      // if phone number doesn't start with +, we need to add the country code to the full phone number
      if (!phone.startsWith('+'))
        // so we add the country code to the phone number
        phone = country?.dialCode + phone
    }
  }
  else {
    // if there is no country code and phone starts with +
    if (phone.startsWith('+')) {
      // return with the mask of the phone number length because we don't know what country mask to use
      mask = `+${Array.from({ length: phone.length + 1 }).join('X')}`
    }
  }

  // and remove all the dashes from the phone number
  phone = phone.replace(/-/g, '')
  return { phone, mask }
}
